(function ($) {

    function validateCharInputDocument(){

        //First step form select
        let selectFirstStep = document.querySelector('.step-1 + .js-form-type-select .form-select');
        let valueSelected = selectFirstStep?.options[selectFirstStep.selectedIndex].value;

        switch (valueSelected) {
            // Document type (nit)
			case '6':
                const lastChar = this.value[this.value.length - 1];
               
                // Char is not numeric
                if(isNaN(lastChar)){
                    this.value = this.value.slice(0,-1);
                }

                // Char is empty or is the space key
                if(lastChar == " "){
                    this.value = this.value.slice(0,-1);
                }
        
				break;
		}
    }

    function validatePasteInputDocument(event){

        //First step form select
        let selectFirstStep = document.querySelector('.step-1 + .js-form-type-select .form-select');
        let valueSelected = selectFirstStep?.options[selectFirstStep.selectedIndex].value;

        switch (valueSelected) {
            // Document type (nit)
			case '6':
                event.preventDefault();
                const paste = (event.clipboardData || window.clipboardData).getData("text");
                const pasteArray = Array.from(paste);
                const value = [];
               
                if(pasteArray.length){

                    pasteArray.forEach(char => {

                        if(isNaN(char) || char == " ") return;

                        value.push(char);

                    })

                    this.value = value.join('').toString();

                }
        
				break;
		}

    }
	
    Drupal.behaviors.documentNumberFrontPage = {
		attach: function (context, settings) {

			let formAjax = false;

			if(context === document.querySelector('.data-update-form')){
				formAjax = true;
			}

			if(context === document || formAjax){

                //First step number document
                let documentNumberFirstStep = document.querySelector('.step-1 ~ .js-form-type-textfield .form-text');

                if(!documentNumberFirstStep) return;

                documentNumberFirstStep.addEventListener('input',validateCharInputDocument);

                documentNumberFirstStep.addEventListener('paste',validatePasteInputDocument);

			}
		
		}	

	};

})(jQuery);
